import styled from "styled-components";
import { FADE, t } from "theme";

// Styled component for the notifications container
/**
 * The log is time passing, so it is set loose: a narrow measure with generous leading, read as
 * an accumulation rather than a list. It fills its grid track instead of the old fixed 200px,
 * which was narrow enough to break most lines mid-phrase.
 *
 * The height caps against the viewport so the gradient finishes fading inside the window rather
 * than running off the bottom edge.
 *
 * The stops come from --log-from / --log-to rather than straight off the palette. A
 * background-image cannot be transitioned, so painting the gradient with theme values made
 * the whole log snap to the other palette at dusk while the page behind it was still fading —
 * light text on a still-white page, and then the reverse at dawn. The two custom properties
 * are registered as typed colours (index.css) and transitioned on :root (Theme.style.js), so
 * the log now crosses over with everything else. The colours themselves are unchanged.
 */
const NotificationsContainer = styled.div`
  position: relative;
  height: min(700px, 78vh);
  width: 100%;
  overflow: hidden;
  text-align: left;
  font-family: serif;
  line-height: 1.5;

  @supports (-webkit-background-clip: text) or (background-clip: text) {
    background: linear-gradient(
      var(--log-from, ${t("logFrom")}),
      var(--log-to, ${t("logTo")})
    );
    background-clip: text;
    color: transparent;
  }
`;

// Styled component for individual notifications
const Notification = styled.div`
  margin-bottom: 0.9rem;
  display: list-item; /* Workaround Safari bug */
`;

// Styled component for protagonist dialog
const Dialog = styled.div`
  margin-bottom: 0.9rem;
  display: list-item; /* Workaround Safari bug */
  font-style: italic;
`;

const TooltipContainer = styled.div`
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.2s linear, color ${FADE};
  color: ${t("fg")};
  width: 80%;
  position: absolute;
  top: 0;
`;

const EventContainer = styled.div`
  &:hover {
    ${TooltipContainer} {
      visibility: visible;
      opacity: 1;
    }
  }
`;
// Styled component for event-related notifications
// No theme transition here on purpose. The only colour this sets is the hover one, over the
// container's transparent text — putting it on the shared clock would make pointing at a
// logged event take the better part of a second to acknowledge you.
const Event = styled.div`
  margin-bottom: 0.9rem;
  display: list-item; /* Workaround Safari bug */

  &:hover {
    color: ${t("logHover")};
    cursor: pointer;
    text-decoration: underline;
  }
`;

export {
  Dialog,
  Event,
  EventContainer,
  Notification,
  NotificationsContainer,
  TooltipContainer,
};
